import React, { useContext, useEffect, useRef } from 'react';
import { Button, Collapse, Nav, Navbar } from 'reactstrap';
import { LogOut } from 'lucide-react';
import Logo from './Logo';
import NavbarVerticalMenu from './NavbarVerticalMenu';
import ToggleButton from './ToggleButton';
import AppContext from '../../context/Context';
import Flex from '../common/Flex';
import useNavRoutes from './useNavRoutes';
import { navbarBreakPoint } from '../../config';
import { useDispatch } from 'react-redux';
import { UnselectCondominium } from '../../actions/condominiumActions';
import { useHistory } from 'react-router';

const NavbarVertical = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const { routes, role, mustSelectProperty, selectedCondominium } = useNavRoutes();
  const navBarRef = useRef(null);
  const { showBurgerMenu, isNavbarVerticalCollapsed, setIsNavbarVerticalCollapsed } = useContext(AppContext);
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  //Control Component did mount and unmounted of hover effect
  if (isNavbarVerticalCollapsed) {
    HTMLClassList.add('navbar-vertical-collapsed');
  }

  useEffect(() => {
    return () => { HTMLClassList.remove('navbar-vertical-collapsed-hover'); }
  }, [isNavbarVerticalCollapsed, HTMLClassList]);

  //Control mouseEnter event
  let time = null;
  const handleMouseEnter = () => {
    if (isNavbarVerticalCollapsed) {
      time = setTimeout(() => {
        HTMLClassList.add('navbar-vertical-collapsed-hover');
      }, 100);
    }
  }

  return (
    <Navbar expand={navbarBreakPoint} className="navbar-vertical navbar-glass" light>
      <Flex align="center">
        <ToggleButton
          isNavbarVerticalCollapsed={isNavbarVerticalCollapsed}
          setIsNavbarVerticalCollapsed={setIsNavbarVerticalCollapsed}
        />
        <Logo at="navbar-vertical" bordered width={100} />
      </Flex>

      <Collapse
        navbar
        isOpen={showBurgerMenu}
        innerRef={navBarRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => {
          clearTimeout(time);
          HTMLClassList.remove('navbar-vertical-collapsed-hover');
        }}
      >
        {/* Scroll nativo y fino (antes react-scrollbars-custom, que reservaba
            10px a la derecha y cortaba los nombres largos del menú). */}
        <div className="hl-sidebar-scroll">
          <Nav navbar vertical>
            <NavbarVerticalMenu routes={routes} />
          </Nav>

          {role === 'manager' && selectedCondominium &&
            <div className="hl-sidebar-footer">
              <Button
                color="falcon-default"
                size="sm"
                block
                className="d-flex align-items-center justify-content-center btn-purchase"
                onClick={() => {
                  dispatch(UnselectCondominium());
                  history.push("/dashboard/app");
                }}
              >
                <LogOut size={15} strokeWidth={2} className="mr-2" aria-hidden="true" />
                Dejar condominio
              </Button>
            </div>
          }
          {role === 'manager' && !selectedCondominium &&
            <p className="hl-sidebar-footer__hint mt-2">Debes seleccionar un condominio</p>}
          {mustSelectProperty &&
            <p className="hl-sidebar-footer__hint mt-2">Debes seleccionar una propiedad</p>}
        </div>
      </Collapse>
    </Navbar>
  )
}

export default React.memo(NavbarVertical);